import React from 'react';
import { SketchPicker } from 'react-color';

/**
 * @param {import('react-color').SketchPickerProps} props
 */
export const BaseSketchPicker = (props) => {
    return <SketchPicker disableAlpha={true} presetColors={[]} {...props} />;
};
